export const lightProfileConstants = {
  GET_LIGHT_PROFILE_REQUEST: 'LIGHTPROFILE/GET_LIGHT_PROFILE_REQUEST',
  GET_LIGHT_PROFILE_SUCCESS: 'LIGHTPROFILE/GET_LIGHT_PROFILE_SUCCESS',
  GET_LIGHT_PROFILE_FAILURE: 'LIGHTPROFILE/GET_LIGHT_PROFILE_FAILURE',

  LOAD_MORE_GROUPS_REQUEST: 'LIGHTPROFILE/LOAD_MORE_GROUPS_REQUEST',
  LOAD_MORE_GROUPS_SUCCESS: 'LIGHTPROFILE/LOAD_MORE_GROUPS_SUCCESS',
  LOAD_MORE_GROUPS_FAILURE: 'LIGHTPROFILE/LOAD_MORE_GROUPS_FAILURE',

  LOAD_MORE_MIXRS_REQUEST: 'LIGHTPROFILE/LOAD_MORE_MIXRS_REQUEST',
  LOAD_MORE_MIXRS_SUCCESS: 'LIGHTPROFILE/LOAD_MORE_MIXRS_SUCCESS',
  LOAD_MORE_MIXRS_FAILURE: 'LIGHTPROFILE/LOAD_MORE_MIXRS_FAILURE',

  OPEN_MODAL: 'LIGHTPROFILE/OPEN_MODAL',
  CLOSE_MODAL: 'LIGHTPROFILE/CLOSE_MODAL',

  CLEAR_DATA: 'LIGHTPROFILE/CLEAR_DATA'
}
